import { z } from "zod";

/** Body for `PUT /api/admin/bu-instance-label`. */
export const updateBuInstanceLabelSchema = z.object({
  label: z.string().trim().min(1, "Label is required").max(100, "Label is too long"),
});

export type UpdateBuInstanceLabelInput = z.infer<typeof updateBuInstanceLabelSchema>;
